var _desc, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 80,
    viewBox: "0 0 90 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M45 46.46L45 27.5C45 23.35 41.64 20 37.5 20L12.5 20C8.35 20 5 23.35 5 27.5L5 41.46L10.73 35.73C11.7 34.75 13.29 34.75 14.26 35.73L27.5 48.96L35.73 40.73C36.7 39.75 38.29 39.75 39.26 40.73L45 46.46ZM44.93 53.47L37.5 46.03L29.26 54.26C28.29 55.24 26.7 55.24 25.73 54.26L12.5 41.03L5 48.53L5 52.5C5 56.64 8.35 60 12.5 60L37.5 60C41.31 60 44.46 57.15 44.93 53.47ZM12.5 15L37.5 15C44.4 15 50 20.59 50 27.5L50 52.5C50 59.4 44.4 65 37.5 65L12.5 65C5.59 65 0 59.4 0 52.5L0 27.5C0 20.59 5.59 15 12.5 15ZM32.5 25L37.5 25C38.88 25 40 26.11 40 27.5L40 32.5C40 33.88 38.88 35 37.5 35L32.5 35C31.11 35 30 33.88 30 32.5L30 27.5C30 26.11 31.11 25 32.5 25ZM62.5 55C61.11 55 60 53.88 60 52.5C60 51.11 61.11 50 62.5 50L87.5 50C88.88 50 90 51.11 90 52.5C90 53.88 88.88 55 87.5 55L62.5 55ZM62.5 30C61.11 30 60 28.88 60 27.5C60 26.11 61.11 25 62.5 25L87.5 25C88.88 25 90 26.11 90 27.5C90 28.88 88.88 30 87.5 30L62.5 30ZM2.5 5C1.11 5 0 3.88 0 2.5C0 1.11 1.11 0 2.5 0L87.5 0C88.88 0 90 1.11 90 2.5C90 3.88 88.88 5 87.5 5L2.5 5ZM2.5 80C1.11 80 0 78.88 0 77.5C0 76.11 1.11 75 2.5 75L87.5 75C88.88 75 90 76.11 90 77.5C90 78.88 88.88 80 87.5 80L2.5 80Z",
    fill: "#000000",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath);
export default __webpack_public_path__ + "static/media/path.7543dc22950dfe9d25f9cac34fe430ef.svg";
export { ForwardRef as ReactComponent };